/* eslint-disable import/prefer-default-export */
import { ErrorCode, ErrorInfo } from './types';

export const getErrorInfoByCode = (status: ErrorCode): ErrorInfo => {
  switch (status) {
    case ErrorCode.NotFound:
      return {
        title: 'Page was not found',
        message: 'The page you are looking for does not exist. Did you follow a link?',
        image: 'not-found-illustration.svg',
      };
    case ErrorCode.Unauthorized:
      return {
        title: 'Your session has expired.',
        message: 'Sign in to pick up where you left off.',
        image: 'session-expired-illustration.png',
      };
    case ErrorCode.UnknownError:
    default:
      return {
        title: 'Something went wrong.',
        message: 'Failed to load the page. Please try again later.',
        image: 'unknown-error-illustration.png',
      };
  }
};
